import {
  CheckableSelectItem,
  DropdownSelectMultiple,
} from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import type { Team } from 'lib-shared-legacy-types';
import { PureComponent } from 'react';

import type { WithTeamsInjectedProps } from 'hocs';

import styles from './teamsSelect.module.scss';

export interface TeamsSelectOwnProps {
  selectedItems: Array<Team>;
  selectTeam: (agent: Team) => void;
  deselectTeam: (agent: Team) => void;
  buttonText?: string;
  queueId?: string;
}

export type TeamsSelectProps = WithTeamsInjectedProps & TeamsSelectOwnProps;

export class TeamsSelect extends PureComponent<TeamsSelectProps> {
  static defaultProps = {
    buttonText: '+Add team',
  };

  getExtraParams() {
    const { queueId } = this.props;
    const params: Record<string, unknown> = {};

    if (queueId) {
      params.filter_out_by_queue = queueId;
    }

    return params;
  }

  componentDidMount() {
    this.props.teams.setExtraParams(this.getExtraParams()).then(() => {
      this.props.teams.getItems();
    });
  }

  @boundMethod
  handleChange(team: Team, isSelected: boolean) {
    const { selectTeam, deselectTeam } = this.props;

    if (isSelected) {
      selectTeam(team);
    } else {
      deselectTeam(team);
    }
  }

  @boundMethod
  handleMenuToggle(isOpen: boolean) {
    if (!isOpen && this.props.teams.searchTerm) {
      // `DropdownSelectMultiple` removes `searchTerm` on close, so we need to handle that
      this.props.teams.searchTermChange('', 0);
    }
  }

  render() {
    const { teams, selectedItems, deselectTeam, buttonText } = this.props;

    const {
      items,
      searchTermChange,
      getItemsAsyncStatus,
      searchTerm,
      hasNextPage,
      hasPreviousPage,
      nextPage,
      previousPage,
    } = teams;

    const tooltipItems = [...items, ...selectedItems];

    return (
      <DropdownSelectMultiple
        selectedItems={selectedItems}
        onRemove={deselectTeam}
        containerProps={{ className: styles.teamsSelectContainer }}
        items={items}
        itemComponent={CheckableSelectItem}
        tooltipItems={Object.assign(
          {},
          ...tooltipItems.map((i) => ({
            [i.id]: { content: i.name, dark: true },
          })),
        )}
        onSearch={searchTermChange}
        onChange={this.handleChange}
        keepOpen
        hasSearch
        buttonProps={{ isLoading: getItemsAsyncStatus === 'loading' }}
        emptyMessage={searchTerm ? 'No teams found' : 'No teams available'}
        buttonText={buttonText}
        pagination={{
          nextEnable: hasNextPage,
          previousEnable: hasPreviousPage,
          onNext: nextPage,
          onPrevious: previousPage,
        }}
        onToggle={this.handleMenuToggle}
      />
    );
  }
}
